<template>
    <div class="videoResume">
        <div class="card p-4 pl-lg-5" v-if="profileVideoDetails === null || profileVideoDetails.videoLink === null">
            <div class="card-body col-12 text-center pt-5 pb-5">
                <div class="p-2 d-flex flex-column text-center">
                    <img src="../../../assets/no_video.svg" width="novideo" class="img-md-fluid img-sm-fluid no-video pl-5 pr-5 pb-4">
                    <span class="oopsnext proximanova">Video Profile not available</span>
                </div>
            </div>
        </div>
        <div class="col-12 pl-0 pr-0 mb-4 card introvideocard"  v-else>
            <div class="card overlay-gradient">
                <div>
                    <video height="300" oncontextmenu="return false" :src="profileVideoDetails.videoLink"  @ended="onenddisplayreplayIcon()" @waiting="displayLoadingLogo()" @canplay="stopLoadingLogo()" controlsList="nodownload"  id="profileVideo" ></video>
                </div>
                <div class="card-img-overlay">
                    <div class="row no-gutters mb-3 ml-0 mr-0 pb-3 companyvid_overlay1 borderradius10">
                        <div class="col ml-4 mt-3 d-flex videoheadsection">
                            <img src="../../../assets/VideoProfile.svg" alt="video" class="img-fluid" />
                            <div class="d-flex flex-column ml-2">
                                <span class="ml-2 mr-2 proximanova-semibold fontsize16 white">Profile Video</span>
                                <span class="ml-2 mr-2 proximanova fontsize14 white">{{profileVideoDetails.creationD | moment("ll") }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <img src="../../../assets/play_video.svg" v-if="!playingProfileVideo" class="playpausevideobtn" alt="playvideo" @click="playProfileVideo">
                        <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="playingProfileVideo && replayProfileVideo">
                            <img src="../../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayVideo()">
                        </div>
                        <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="playingProfileVideo && loadingProfileVideo">
                            <img src="../../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="loading">
                        </div>
                        <img src="../../../assets/Pausevideo.svg" class="playpausevideobtn pausebtn" v-if="playingProfileVideo && !replayProfileVideo && !loadingProfileVideo" alt="pausevideo" @click="playProfileVideo">
                    </div>
                    <div class="bottom">
                        <div class="companyvid_overlay2 borderradius10">
                            <div class="p-3 ml-3 d-flex flex-column">
                                <span class="fontsize16 white stylebold proximanova" v-if="profileVideoDetails.videoTitle"> {{profileVideoDetails.videoTitle}}</span>
                                <span v-if="profileVideoDetails.videoDescription" class="fontsize14 white60 proximanova text-capitalize">{{profileVideoDetails.videoDescription}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props : [
        'jobApplicantDetails'
    ],
    data() {
        return{
            profileVideoDetails : null,
            playingProfileVideo : false,
            replayProfileVideo : false,
            loadingProfileVideo : false,
        }
    },
    mounted(){
        this.profileVideoDetails = this.jobApplicantDetails.profileVideoDetails
    },
    methods : {
        // this will invoke after click on play/pause button on team video card to play/pause the video
        playProfileVideo : function() {
            var profilevideo = document.getElementById('profileVideo')
            if(!this.playingProfileVideo) {
                this.playingProfileVideo = true
                profilevideo.play()
            }else{
                this.playingProfileVideo = false;
                profilevideo.pause()
            }
        },
        onenddisplayreplayIcon() {
            this.replayProfileVideo = true;
            this.loadingProfileVideo = false;
        },
        displayLoadingLogo() {
            this.loadingProfileVideo = true;
        },
        stopLoadingLogo() {
            this.loadingProfileVideo = false;
        },
        replayVideo() {
            this.replayProfileVideo = false;
            this.loadingProfileVideo = false;
            this.playingProfileVideo = false;
            this.playProfileVideo()
        }
    }
}
</script>
<style scoped>
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.playpausevideobtn{
  margin-left: 46%;
  margin-top: 5%;
  cursor: pointer;
}
.pausebtn{
  display: none;
}
.introvideocard:hover .pausebtn{
  display: block;
  margin-top: 7% !important;
}
#profileVideo{
  width: 100%;
}
.bottom{
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
#playvideobtn {
  /* display: none; */
  margin-left: 46%;
  margin-top: 7% !important;
  cursor: pointer;
}
.companyvid_overlay1{
	background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%);
}
.companyvid_overlay2{
	background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 100%);
}
@media screen and (min-width: 600px) {
  .no-video {
    width: 45%;
    align-self: center;
  }
}
</style>